var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15C4.32168 15 0.266992 8.1555 0.0984375 7.86431C-0.0328125 7.63763 -0.0328125 7.36219 0.0984375 7.1355C0.266992 6.8445 4.32168 0 12.5 0C20.6783 0 24.733 6.8445 24.9016 7.13569C25.0328 7.36237 25.0328 7.63781 24.9016 7.8645C24.733 8.1555 20.6783 15 12.5 15ZM1.70059 7.49887C2.62988 8.85094 6.27852 13.5 12.5 13.5C18.7412 13.5 22.3736 8.85469 23.2994 7.50112C22.3701 6.14906 18.7215 1.5 12.5 1.5C6.25879 1.5 2.62637 6.14531 1.70059 7.49887ZM12.5 12C9.91523 12 7.8125 9.98137 7.8125 7.5C7.8125 5.01862 9.91523 3 12.5 3C15.0848 3 17.1875 5.01862 17.1875 7.5C17.1875 9.98137 15.0848 12 12.5 12ZM12.5 4.5C10.777 4.5 9.375 5.84588 9.375 7.5C9.375 9.15413 10.777 10.5 12.5 10.5C14.223 10.5 15.625 9.15413 15.625 7.5C15.625 5.84588 14.223 4.5 12.5 4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewicon);
export default __webpack_public_path__ + "static/media/previewicon.23cc248596d9e4598d7c1d1e2e225a3b.svg";
export { ForwardRef as ReactComponent };